module.exports = __webpack_public_path__ + "assets/icon-chat-component.0267e5b4.svg";